import { Fade, Modal, Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { useEffect } from "react";
import { useState } from "react";
import CustomAutoComplete from "../../../common/CustomAutoComplete";
import { updateObjectStateValue } from "../../../utils/FunctionHelpers";
import { addCandidatsToSelection, getAllCadidatSelections } from "../../../services/SelectionCandidatService";
import DialogDeleteCustom from "../../../components/DialogDeleteCustom/DialogDeleteCustom";
import { AppButton } from "../../../components/UI";

const paperStyle = {
  backgroundColor: '#fff',
  boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
  padding: '24px 32px',
  borderRadius: '16px',
  minWidth: '380px',
  maxWidth: '95vw',
  outline: 'none',
};

const ChooseSelectionModal = ({ children, selectedCandidats, snackbarShowMessage, history }) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectionData, setSelectionData] = useState({
    isLoading: false,
    data: [],
    label: "SELECTION",
    required: true,
    selection: null,
    errors: {}
  });

  const validate = async () => {
    let temp = {};
    temp.selection = selectionData.selection ? "" : "Le champ 'NOM DE LA SÉLECTION' est obligatoire.";
    setSelectionData((prevState) => ({ ...prevState, errors: { ...temp } }));
    return Object.values(temp).every((x) => x === "");
  };

  const loadSelections = () => {
    updateObjectStateValue(setSelectionData, { isLoading: true, data: [] });
    getAllCadidatSelections('?archived=false').then(({ data }) => {
      updateObjectStateValue(setSelectionData, { isLoading: false, data: data.candidatsSelections });
    }).catch(() => {
      snackbarShowMessage("Erreur de chargement des sélections.", "error", 4000);
    }).finally(() => {
      updateObjectStateValue(setSelectionData, { isLoading: false });
    });
  };

  const handleClose = () => setOpenModal(false);
  const handleOpen = () => setOpenModal(true);

  const handleChange = (event) => {
    setSelectionData((prevState) => ({ ...prevState, [event.target.name]: event.target.value }));
  };

  const handleSelectionChange = (selection) => {
    handleChange({ target: { name: 'selection', value: selection } });
  };

  const handleFilterSelection = () => {
    if (validate() && selectionData.selection != undefined) {
      history.push({
        pathname: `/selections/${selectionData.selection.id}/candidats/${selectedCandidats[0]}/view`,
        state: {
          numbersTotalOfSelections: selectedCandidats.length,
          candidatsInList: selectedCandidats,
          candidatIndex: selectedCandidats.indexOf(selectedCandidats[0]),
          filtering: true
        },
      });
    }
  };

  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [loadToDelete, setLoadToDelete] = useState(false);

  const handleRemoveSelection = async () => {
    if (validate() && selectionData.selection != undefined) {
      setLoadToDelete(true);
      await addCandidatsToSelection(selectionData.selection.id, { deletedCandidats: selectedCandidats, selectedCandidats: [] })
        .then(({ data }) => snackbarShowMessage(data))
        .catch(({ response }) => snackbarShowMessage(response.data.error.detail, "error", 4000))
        .finally(() => {
          handleCloseDialog();
          handleClose();
          setLoadToDelete(false);
        });
    }
  };

  const handleCloseDialog = () => {
    if (loadToDelete) return;
    setOpenDialogDelete(false);
  };
  const handleOpenDialog = () => setOpenDialogDelete(true);

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    open: openDialogDelete,
    loading: loadToDelete,
    title: "Supprimer les Candidats de la sélection"
  };

  useEffect(() => {
    if (openModal) loadSelections();
    return () => {
      setSelectionData({
        isLoading: false, data: [], label: "SELECTION", required: true, selection: null, errors: {}
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const body = (
    <div style={paperStyle} className="crm-selection-refine-modal">
      <div className="modal-header" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', marginBottom: '16px' }}>
        <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', fontFamily: "'Fira Sans', sans-serif" }}>
          Affiner et ajouter à une sélection existante
        </Typography>
        <IconButton
          aria-label="Fermer"
          onClick={handleClose}
          size="small"
          className="crm-modal-close"
        >
          <Close fontSize="small" />
        </IconButton>
      </div>
      <div className="modal-body crm-selection-refine-modal__body">
        <CustomAutoComplete disablePortal={false}
          listData={selectionData}
          errors={selectionData.errors}
          value={selectionData.selection}
          handleDataChange={handleSelectionChange}
          name="selection"
        />
      </div>
      <div className="crm-selection-refine-modal__footer">
        <AppButton variant="primary" onClick={handleFilterSelection}>
          Affiner la sélection
        </AppButton>
        <AppButton variant="danger" onClick={handleOpenDialog}>
          Supprimer
        </AppButton>
        <AppButton variant="secondary" onClick={handleClose}>
          Annuler
        </AppButton>
      </div>
    </div>
  );

  return (
    <>
      {children(handleOpen)}
      <Modal
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={openModal}>{body}</Fade>
      </Modal>
      <DialogDeleteCustom
        {...dialogDeleteProps}
        handleConfirm={() => handleRemoveSelection()}
        label={`Voulez-vous vraiment supprimer les Candidats de la sélection ${selectionData.selection?.selectionName} ?`}
      />
    </>
  );
};

export default ChooseSelectionModal;
